(() => {
  'use strict';
  const element = document.getElementById('cjau-free-shipping-config');
  if (!element || window.cjauShippingExperimentInstalled) return;
  const config = JSON.parse(element.textContent);
  const now = Date.now();
  const start = Date.parse(config.startAt), end = Date.parse(config.endAt);
  if (!config.preview && (!config.enabled || !Number.isFinite(start) || !Number.isFinite(end) || now < start || now >= end)) return;
  window.cjauShippingExperimentInstalled = true;
  const assignmentKey = 'cjau-shipping-offer-20261005-v3-preview';
  const nativeFetch = window.fetch.bind(window);
  let cart = null;
  let refreshTimer;
  let checkoutPending = false;
  let revision = 0;
  const panel = document.getElementById('cjau-ab-review');
  const validGroup = value => value === 'control' || value === 'treatment';
  function storedGroup() {
    try { const value = localStorage.getItem(assignmentKey); if (validGroup(value)) return value; } catch (error) {}
    const cookie = document.cookie.split('; ').find(value => value.startsWith(assignmentKey + '='));
    return cookie ? decodeURIComponent(cookie.slice(assignmentKey.length + 1)) : null;
  }
  let group = panel && panel.getAttribute('data-review-group') || storedGroup();
  if (!validGroup(group)) group = crypto.getRandomValues(new Uint8Array(1))[0] < 128 ? 'control' : 'treatment';
  function persist() {
    try { localStorage.setItem(assignmentKey, group); } catch (error) {}
    document.cookie = assignmentKey + '=' + group + '; Max-Age=2419200; Path=/; SameSite=Lax; Secure';
  }
  persist();
  const root = config.cartUrl.replace(/cart\/?$/, '');
  const cartEndpoint = config.cartUrl + '.js';
  const updateEndpoint = config.cartUrl + '/update.js';
  const checkoutUrl = root + 'checkout';
  const money = cents => '$' + (cents / 100).toFixed(2);
  const treatment = () => group === 'treatment' && config.currency === 'AUD' && (!cart || cart.currency === 'AUD');
  const setText = (node, text) => { if (node.textContent !== text) node.textContent = text; };
  function setMessage(node, text) {
    const headline = node.matches('[data-cjau-fs-banner], [data-cjau-fs-product]');
    let main = node.querySelector('[data-cjau-fs-main]');
    if (!main) {
      node.textContent = '';
      main = document.createElement('span');
      main.setAttribute('data-cjau-fs-main', '');
      node.appendChild(main);
      let detailsTarget = node;
      if (headline) {
        const disclosure = document.createElement('details');
        disclosure.className = 'cjau-fs-disclosure';
        const summary = document.createElement('summary');
        summary.textContent = config.strings.details;
        disclosure.appendChild(summary);
        node.appendChild(disclosure);
        detailsTarget = disclosure;
      }
      const conditions = document.createElement('small');
      conditions.className = 'cjau-fs-details';
      conditions.setAttribute('data-cjau-fs-conditions', '');
      detailsTarget.appendChild(conditions);
      const preview = document.createElement('small');
      preview.className = 'cjau-fs-preview-note';
      preview.setAttribute('data-cjau-fs-preview', '');
      detailsTarget.appendChild(preview);
    }
    setText(main, text);
    setText(node.querySelector('[data-cjau-fs-conditions]'), headline ? config.strings.headlineConditions : config.strings.conditions);
    const preview = node.querySelector('[data-cjau-fs-preview]');
    preview.hidden = !config.preview;
    setText(preview, config.preview ? config.strings.previewLabel : '');
  }
  function notice(selector, target, kind) {
    let node = document.querySelector(selector);
    if (!node && target) {
      node = document.createElement('div');
      node.className = 'cjau-fs-message cjau-fs-message--' + kind;
      node.setAttribute('data-cjau-fs-' + kind, '');
      node.setAttribute('aria-live', 'polite');
      target.prepend(node);
    }
    return node;
  }
  function render() {
    const show = treatment();
    const banner = document.querySelector('[data-cjau-fs-banner]');
    if (banner) { banner.hidden = !show; setMessage(banner, config.strings.banner); }
    const product = notice('[data-cjau-fs-product]', show && document.querySelector('.product-form'), 'product');
    const message = notice('[data-cjau-fs-cart]', show && document.querySelector('.checkout-subtotal-container__right'), 'cart');
    const usable = show && cart && Number.isFinite(cart.total_price);
    const remaining = usable ? Math.max(0, config.thresholdCents - cart.total_price) : null;
    if (product) {
      product.hidden = !show;
      const productMessage = usable ? (remaining === 0 ? config.strings.cartUnlocked : config.strings.cartRemaining.replace('__AMOUNT__', money(remaining))) : config.strings.product;
      setMessage(product, productMessage);
      product.dataset.thresholdMet = usable && remaining === 0 ? 'true' : 'false';
    }
    if (message) {
      message.hidden = !usable;
      if (usable) {
        setMessage(message, remaining === 0 ? config.strings.cartUnlocked : config.strings.cartRemaining.replace('__AMOUNT__', money(remaining)));
        message.dataset.thresholdMet = remaining === 0 ? 'true' : 'false';
      }
    }

  }
  async function json(url, options) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await nativeFetch(url, { credentials: 'same-origin', ...options, signal: controller.signal });
      if (!response.ok) throw new Error('Cart request failed');
      return await response.json();
    } finally { clearTimeout(timer); }
  }
  function attributes() {
    return { cjau_shipping_experiment: config.experimentId, cjau_shipping_variant: group, cjau_shipping_offer: group === 'treatment' ? 'free_shipping_149_rate_9_95' : 'control' };
  }
  async function tag(current) {
    const values = attributes();
    if (!current.item_count || Object.keys(values).every(key => current.attributes && current.attributes[key] === values[key])) return current;
    return json(updateEndpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: values }) });
  }
  async function refresh() {
    const currentRevision = ++revision;
    try {
      const next = await tag(await json(cartEndpoint, { headers: { Accept: 'application/json' } }));
      if (currentRevision === revision) { cart = next; render(); }
    } catch (error) { if (currentRevision === revision) { cart = null; render(); } }
  }
  function scheduleRefresh() { clearTimeout(refreshTimer); refreshTimer = setTimeout(refresh, 150); }
  function impression() {
    if (config.preview || !config.analyticsEnabled) return;
    const key = config.experimentId + ':' + group;
    try { if (sessionStorage.getItem(key)) return; } catch (error) {}
    const data = { experiment_id: config.experimentId, experiment_variant: group };
    if (typeof window.gtag === 'function') { window.gtag('set', 'user_properties', data); window.gtag('event', 'experiment_impression', data); }
    else { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'experiment_impression', ...data }); }
    try { sessionStorage.setItem(key, '1'); } catch (error) {}
  }
  function restoreError() {
    checkoutPending = false;
    const target = document.querySelector('.checkout-subtotal-container__right') || document.querySelector('#cart-summary-overlay .cart-summary-overlay__actions') || document.querySelector('.product-form');
    const node = notice('[data-cjau-fs-error]', target, 'error');
    if (node) { node.hidden = false; setText(node, config.strings.error); }
  }
  async function route(event, form, destination) {
    if (event.defaultPrevented || checkoutPending) { if (checkoutPending) event.preventDefault(); return; }
    event.preventDefault();
    checkoutPending = true;
    ++revision;
    try {
      let next;
      if (form) {
        const values = new FormData(form);
        values.delete('checkout'); values.delete('update');
        Object.entries(attributes()).forEach(([key, value]) => values.set('attributes[' + key + ']', value));
        next = await json(updateEndpoint, { method: 'POST', headers: { Accept: 'application/json' }, body: values });
      } else next = await tag(await json(cartEndpoint, { headers: { Accept: 'application/json' } }));
      cart = next; render();
      const target = new URL(destination || checkoutUrl, location.origin);
      if (treatment()) {
        const codes = (target.searchParams.get('discount') || '').split(',').filter(Boolean);
        if (!codes.includes(config.discountCode)) codes.push(config.discountCode);
        target.searchParams.set('discount', codes.join(','));
      }
      window.location.assign(target.href);
    } catch (error) { restoreError(); }
  }
  document.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest && event.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && url.pathname.replace(/\/$/, '') === checkoutUrl.replace(/\/$/, '')) route(event, null, url.href);
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.id !== 'cartform' || !event.submitter || event.submitter.name !== 'checkout') return;
    if (event.submitter.hasAttribute('formaction') || form.querySelector('[name="discount"]')) return;
    route(event, form, checkoutUrl);
  });
  document.addEventListener('change', event => {
    if (event.target.id === 'cjau-ab-group' && validGroup(event.target.value)) {
      group = event.target.value; persist(); render(); scheduleRefresh();
    }
  });
  if (window.jQuery) {
    jQuery(document).on('ajaxSuccess.cjauShipping', (event, xhr, options) => {
      if (/\/cart\/(?:add|change|update)(?:\.js)?(?:\?|$)/.test(options.url || '')) scheduleRefresh();
    });
  }
  ['cart:updated', 'cart:refresh'].forEach(name => document.addEventListener(name, scheduleRefresh));
  window.addEventListener('pageshow', scheduleRefresh);
  new MutationObserver(records => {
    let opened = false;
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1 && (node.id === 'cart-summary-overlay' || node.querySelector('#cart-summary-overlay'))) opened = true;
    }));
    render();
    if (opened) scheduleRefresh();
  }).observe(document.body, { childList: true, subtree: true });
  render(); impression(); refresh();
})();
